module.exports = __webpack_public_path__ + "img/DWB_logo.e4d796f0.png";